import { ObjectManager } from '../../../concepts/objects';
import { ActiveObject, resolve } from '../../Container';
import { Camera } from '../../canvas/Camera';
import { RelativeTo } from '../../canvas/entities/Physical';
import { IsCreating } from '../../canvas/tooling/CreatePhysicalToolBehavior';
import { TextRuler } from '../../canvas/visualization/TextRuler';
import { Text } from './Text';
import { AutoSizingTextSettings } from './TextLayout';

export class TextMechanics extends ActiveObject {

    @resolve(Camera) private camera!: Camera;
    @resolve(ObjectManager) private objects!: ObjectManager;

    public start(): void {
        const { objects, } = this;
        this.burden(
            objects.createTrigger('Text.FixFontSizeForAutoHeight')
                .for(Text).onChangesTo('autoHeight')
                .doForEach(this.applyAutoHeight),
            objects.createTrigger('Text.AutoSizing')
                .for(Text).onChangesTo('content', 'fontSize', 'fontFamily', 'autoHeight')
                .doForEach(this.applyAutoSize),
        );
    }

    private applyAutoHeight = (t: Text) => {
        if (IsCreating.get(t)) return;
        if (t.autoHeight) {
            const autoSettings = AutoSizingTextSettings(t);
            const fixedFontSize = Math.ceil(
                Math.min(
                    autoSettings.maxFontSize,
                    TextRuler.fit(t.content, autoSettings, t.width, t.height),
                )
            );
            t.fontSize = fixedFontSize;
            this.applyAutoSize(t);
        }
    };

    private applyAutoSize = (t: Text) => {
        if (IsCreating.get(t)) return;
        const bounds = t.bounds(RelativeTo.Model);
        const maxWidth = this.camera.getModelFrame().right - 50 - bounds.left;
        if (t.autoHeight) {
            t.sizeToContent(maxWidth);
        }
    };
}
